<template>
  <div class="range-slider">
    <VueSlider v-model="value"
               :contained="true"
               :lazy="true"
               :min="min"
               :max="max"
               tooltipFormatter="&euro; {value}"
               />

    <span class="range-slider__text">
      Van &euro; {{ value[0] }} tot &euro; {{ value[1] }} p.p.
    </span>
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component';

export default {
  name: 'RangeSlider',

  components: {
    VueSlider,
  },

  props: {
    modelValue: {
      type: Array,
    },
    min: {
      type: Number,
    },
    max: {
      type: Number,
    },
  },

  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value[0] !== this.min || value[1] !== this.max ? value : undefined);
      },
    },
  },
};
</script>

<style lang="scss">
  @import '../../assets/css/helpers/colors';

  $bgColor: white;
  $themeColor: #FFC69C;
  $dotBorderRadius: 25%;
  $tooltipBgColor: $color-secondary;
  @import 'vue-slider-component/lib/theme/default.scss';

  .range-slider {

    &__text {
      display: flex;
      justify-content: flex-end;
      margin-top: 6px;
      font-size: 14px;
      line-height: 1;
    }
  }
</style>
